import React, { useState, useEffect } from "react";
import {
  Grid,
  Tab,
  Tabs,
  AppBar,
  Box,
  CircularProgress
} from '@mui/material';
import useAxios from '../../../hooks/useAxios';
import SingleTrade from './SingleTrade';
import ValueTrading from './Value/ValueTrading';
import MomentumTrading from './Momentum/MomentumTrading';
import { useSelector } from "react-redux";
function TabPanel({ value, index, children }) {
  return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
}

const Trade = ({ stockData }) => {
  const [tab, setTab] = useState(0);
  const [momentumStocks, setMomentumStocks] = useState({});
  const [valueStocks, setValueStocks] = useState({});
  const [orderMessage, setOrderMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user_authentication.token);
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const {
    data: getMomentumValueStocks,
    error: errorMomentumValueStocks,
    loading: loadingMomentumValueStocks,
    callAPI: callMomentumValueAPI
  } = useAxios();

  useEffect(() => {
    if (getMomentumValueStocks && loadingMomentumValueStocks) {
      console.log('placeSingleOrder ', getMomentumValueStocks);
      setLoading(false);
      const momentumData = getMomentumValueStocks.data.filter(
        item => item.strategy.toLowerCase() === "momentum"
      );
      setMomentumStocks(momentumData);
      const valueData = getMomentumValueStocks.data.filter(
        item => item.strategy.toLowerCase() === "value"
      );
      setValueStocks(valueData);
    } else if (loadingMomentumValueStocks && errorMomentumValueStocks) {
      setLoading(false);
      console.error(errorMomentumValueStocks);
      setSeverity("error");
      setOrderMessage("Failed to get Price. Please try again.");
    }
  }, ([getMomentumValueStocks, errorMomentumValueStocks, loadingMomentumValueStocks]));

  const s3FetchURL = `${process.env.REACT_APP_S3_TRADE_FETCH_URL}`
  const getMomentumValueStocksKEY = `${process.env.REACT_APP_S3_TRADE_FETCH_KEY}/MomenumValue_Stocks/momentum_value_stocks.json`;

  const fetchMomenTumValueStocks = () => {
    setLoading(true);
    callMomentumValueAPI(
      s3FetchURL,
      "POST",
      { "s3_location": getMomentumValueStocksKEY },
      {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
      }
    );
  };

  useEffect(() => {
    fetchMomenTumValueStocks();
  }, []);


  return (
    <Grid container spacing={3} sx={{ mt: 3 }}>
      {/* Left Side - New Order Form */}
      <AppBar
        position="static"
        color="default"
        sx={{ backgroundColor: "white", boxShadow: "none", borderBottom: "1px solid #e0e0e0" }}
      >
        <Tabs
          value={tab}
          onChange={handleChange}
          variant="fullWidth"
          TabIndicatorProps={{ style: { backgroundColor: "#1976d2", height: 3 } }}
          textColor="primary"
        >
          <Tab
            label="Single Trade"
            sx={{ fontWeight: 500, fontSize: '1rem' }}
          />
          <Tab
            label="Value Trading"
            sx={{ fontWeight: 500, fontSize: '1rem' }}
          />
          <Tab
            label="Momentum Trading"
            sx={{ fontWeight: 500, fontSize: '1rem' }}
          />
        </Tabs>
      </AppBar>

      {loading && (
        <Box
          position="absolute"
          top={250}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={1000}
          bgcolor="rgba(255, 255, 255, 0.6)"
        >
          <CircularProgress size={40} />
        </Box>
      )}
      <TabPanel value={tab} index={0}>
        <SingleTrade stockData={stockData} />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <ValueTrading stocks={valueStocks} />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <MomentumTrading stocks={momentumStocks} />
      </TabPanel>

    </Grid>
  );
};

export default Trade;
